import { BootstrapVue } from 'bootstrap-vue'

const GlobalComponents = {
  install(Vue) {
    Vue.use(BootstrapVue)
  }
}

export default GlobalComponents
